/**
 * Centralised runtime configuration.
 *
 * The backend URL is supplied at build time via `VITE_WS_URL` (a `ws://` /
 * `wss://` origin). The HTTP origin is derived from it — `ws → http`,
 * `wss → https` — so there is a single source of truth and no second env var
 * to keep in sync.
 */

const FALLBACK_WS_URL = "ws://localhost:8080"

function resolveWsUrl(): string {
    const configured = import.meta.env.VITE_WS_URL
    if (configured) return configured.replace(/\/+$/, "")

    // A production build with no backend URL is a deploy misconfiguration —
    // fail loudly rather than silently pointing every user at localhost.
    if (import.meta.env.PROD) {
        throw new Error(
            "VITE_WS_URL is not set. The production build needs the backend WebSocket origin " +
            "(e.g. wss://your-backend.example) available at build time.",
        )
    }
    return FALLBACK_WS_URL
}

/** Backend WebSocket origin, e.g. `wss://api.example` (no trailing slash). */
export const WS_URL = resolveWsUrl()

/** Backend HTTP origin, derived from {@link WS_URL}. */
export const HTTP_URL = WS_URL.replace(/^ws/, "http")
